import React from "react";
import "./style.scss";
import { usePageConfig } from "app/structure/pageConfigContext";

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _sp_: any;
    }
}

const loadPrivacyManager = () => {
    if (
        typeof window !== "undefined" &&
        window._sp_ !== "undefined" &&
        window._sp_.loadPrivacyManagerModal &&
        typeof window._sp_.loadPrivacyManagerModal === "function"
    ) {
        window._sp_.loadPrivacyManagerModal(189193);
    }
};

export const Footer = () => {
    const { imprintUrlOverride } = usePageConfig();

    return (
        <React.Fragment>
            <div className={"six-hint"}>
                <span className={"six-logo"}>

                </span>
            </div>
            <footer data-ga-category="footer" data-ga-action="click">
                <nav>
                    <a
                        href="https://www.t-online.de/kontakt/id_40803478/index"
                        data-ga-label="[href]"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Kontakt
                    </a>
                    <a
                        href="http://www.stroeerdigitalpublishing.de/datenschutz"
                        data-ga-label="[href]"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Datenschutz
                    </a>
                    <a
                        href={imprintUrlOverride || "https://www.t-online.de/impressum/id_12511434/index"}
                        data-ga-label="[href]"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Impressum
                    </a>
                    <button onClick={loadPrivacyManager} className="Tprivacyadmin">
                        Einwilligungsmanagement
                    </button>
                </nav>
                <div className="licencedby">
                <span>
                    t-online.de ist ein Angebot
                    <br />
                    der Ströer Content Group
                </span>
                    <span>licenced by</span>
                    <div className="logocontainer">Deutsche Telekom</div>
                </div>
            </footer>
        </React.Fragment>
    );
};
